import gql from 'graphql-tag';

import actionTypes from './constants';

// import helpers from './../../helpers';

/* */
export const getCreditCard = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_CREDIT_CARD}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ creditCard: data.getCreditCard }));

/* */
export const getCreditCards = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_CREDIT_CARDS}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ creditCards: data.getAccountCreditCards }));

/* */
export const setCreditCard = (client, variables) => {
  // DEBUG-SCC: tracer tous les appels setCreditCard
  // eslint-disable-next-line no-console
  console.warn(
    '[DEBUG-SCC] setCreditCard called',
    JSON.stringify({
      hasAccountId: !!variables.accountId,
      hasWalletId: !!variables.walletId,
      id: variables.id,
      brand: variables.brand,
      accountId: variables.accountId || '(omis)',
      walletId: variables.walletId || '(omis)',
    }),
  );

  return client
    .mutate({
      mutation: gql`
        ${actionTypes.gql.SET_CREDIT_CARD}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ setCreditCard: data.setAccountCreditCard }));
};
